/**
 * @author        woody@zumper.com (Woody Anderson)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   core utilities
 */

// unaccent is in shi[mv].js somewhere

const NOT_ASCII_RE = /[^ -~]/

/**
 * return hyphenized blob. blob can be unicode str, utf-8/ascii encoded str, or None.
 * convert: 'a b / c' to 'a-b-c', optionally (and by default) unaccenting.
 *
 * @param {string} blob
 * @param {boolean} unaccent_
 * @returns {string}
 */
export const hyphenize = (blob, unaccent_ = true) => {
  if (blob) {
    // JS equivalent of: isEncoded = isinstance(blob, str)
    // https://github.com/FGRibreau/node-unidecode
    /*
    const isEncoded = false
    if isEncoded:
      blob = blob.decode('utf-8')
    if unaccent_:
      blob = unidecode.unidecode(blob)
    return result.encode('utf-8') if isEncoded else result
    */
    const result = blob && unaccent_ ? unaccent(blob) : blob
    return result
      .replace(/[^-\w']+/g, '-')
      .replace(/--+/g, '-')
      .replace(/(:?^-+|-+$)/g, '')
      .toLowerCase()
  }
  return ''
}

/**
 * change 'montréal' into 'montreal'
 *
 * @param {string} text
 * @returns {string}
 */
export const unaccent = (text) => {
  if (text.normalize && NOT_ASCII_RE.test(text)) {
    // https://stackoverflow.com/a/37511463/11506025
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }
  return text
}

/**
 * url path hyphenize the parts.  ['a', 'b c'] becomes 'a/b-c'
 *
 * @param parts
 * @returns {string}
 */
export function hyphenizeUrl(...parts) {
  return parts.map(hyphenize).filter(Boolean).join('/')
}

/**
 * remove empty parts, join with '-', then hyphenize. parts MUST be str|unicode.
 *
 * @param parts
 * @returns {string}
 */
export function hyphenate(...parts) {
  return hyphenize(parts.filter(Boolean).join('-'))
}

/**
 * @param str
 */
export function camelize(str) {
  return str
    .split(/[ _]/)
    .filter((part) => !!part)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('')
}
